import { isFunction, isObject } from 'lodash';
class NativeAppBridge {
    constructor() {
        this.notificationType = null;
    }
    notify(notificationType) {
        this.notificationType = notificationType;
        return Promise.allSettled([this.notifyIOS(), this.notifyAndroid()]).then((results) => {
            if (results.some((result) => result.status === 'fulfilled')) {
                return Promise.resolve();
            }
            return Promise.reject();
        });
    }
    notifyAndroid() {
        if (this.notificationType !== null &&
            isObject(window.Android) &&
            isFunction(window.Android[this.notificationType])) {
            window.Android[this.notificationType]();
            return Promise.resolve();
        }
        return Promise.reject();
    }
    notifyIOS() {
        if (isObject(window.webkit) &&
            isObject(window.webkit.messageHandlers) &&
            this.notificationType !== null &&
            isObject(window.webkit.messageHandlers[this.notificationType]) &&
            isFunction(window.webkit.messageHandlers[this.notificationType].postMessage)) {
            window.webkit.messageHandlers[this.notificationType].postMessage('');
            return Promise.resolve();
        }
        return Promise.reject();
    }
}
export const nativeNotifications = new NativeAppBridge();
